import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';

export const CTA = () => {
  return (
    <section className="py-24 md:py-32 bg-brand-green relative overflow-hidden" data-testid="cta-section">
      <div className="absolute inset-0 opacity-10">
        <img src="https://images.unsplash.com/photo-1601560896164-834d6f61ea66?q=85&w=1920" alt="" className="w-full h-full object-cover" />
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 text-center relative z-10">
        <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
          <p className="text-xs md:text-sm uppercase tracking-widest text-brand-gold-light mb-6" data-testid="cta-subtitle">Experience Luxury</p>
          <h2 className="text-4xl md:text-6xl font-heading font-light text-white mb-8" data-testid="cta-title">Book a Private Viewing</h2>
          <p className="text-base md:text-lg text-white/80 font-light max-w-2xl mx-auto mb-12">Let us help you find your perfect home in Bangalore's most exclusive neighborhoods</p>
          <a href="#enquiry" className="inline-flex items-center gap-3 px-8 py-4 bg-brand-gold text-white text-sm font-medium tracking-wide hover:bg-white hover:text-brand-green transition-all duration-300 rounded-lg group" data-testid="cta-button">
            <Phone size={20} className="group-hover:rotate-12 transition-transform" />
            SCHEDULE A VISIT
          </a>
        </motion.div>
      </div>
    </section>
  );
};
